export default __webpack_public_path__ + "static/media/Goldberg.2a6b16a3.png";